module.exports = __webpack_public_path__ + "static/media/Mushrooms.svg";